import React, {createContext, PropsWithChildren, useContext} from 'react';
import {ActorRefFrom} from 'xstate';

import {ConcentrationLayerMachine} from 'samples/plate-maps/concentration-layers/machine/ConcentrationLayerMachine';

type ConcentrationLayerActor = ActorRefFrom<typeof ConcentrationLayerMachine>;

const ScratchPlateConcentrationLayerCtx = createContext<ConcentrationLayerActor | null>(null);

export function useScratchPlateConcentrationLayerActor(): ConcentrationLayerActor {
  const actor = useContext(ScratchPlateConcentrationLayerCtx);
  if (actor == null) {
    throw new Error(
      'useScratchPlateConcentrationLayerActor must be used within ScratchPlateConcentrationLayerProvider'
    );
  }
  return actor;
}

export default function ScratchPlateConcentrationLayerProvider({
  actor,
  children,
}: PropsWithChildren<{actor: ConcentrationLayerActor}>): JSX.Element {
  return (
    <ScratchPlateConcentrationLayerCtx.Provider value={actor}>
      {children}
    </ScratchPlateConcentrationLayerCtx.Provider>
  );
}
